export const count = (array = []) => {
   return array.length
}

export const nl2br = (text = '') => {
   return new Handlebars.SafeString(text.replace(/(\r\n|\n|\r)/gm, '<br>'))
}

/**
   * TODO: Remove this if_equals as now using the if_condition helper instead.
   *
   * if_equals
   * Handlebars helper to check if item is equal to another item.
   *
   * @Example {{#if_equals item1 item2}} ... {{/if_equals}}
*/
export const if_equals = function(a, b, opts) {
   return a === b
 }

 /**
   * if_condition
   * Use this like any traditional if statement.
 */
export const if_condition = function (...args) {
   const conditions = args.slice(0, -1) // All arguments except the last one
   const options = args[args.length - 1]

   let result = false

   // Check each condition using the specified operator
   for (let i = 0; i < conditions.length; i += 2) {
      const v1 = conditions[i]
      const operator = conditions[i + 1]
      const v2 = conditions[i + 2]

      switch (operator) {
         case '==':
            result = v1 == v2
            break;
         case '===':
            result = v1 === v2
            break;
         case '!=':
            result = v1 != v2
            break;
         case '!==':
            result = v1 !== v2
            break;
         case '<':
            result = v1 < v2
            break;
         case '<=':
            result = v1 <= v2
            break;
         case '>':
            result = v1 > v2
            break;
         case '>=':
            result = v1 >= v2
            break;
         case '&&':
            result = v1 && v2
            break;
         case '||':
            result = v1 || v2
            break;
         default:
            result = false;
            break;
      }

      if (result) {
         return options.fn(this)
      }
   }

   return options.inverse ? options.inverse(this) : ''
}

/**
   * get_handlebars_template
   * This file takes content and a path and uses a Promise to
   * return a handlebars template.
   *
   * @param {object} content - The content to be used in the template.
   * @param {string} path - The path and filename of the template.
   * @return void
   *
*/
export const get_handlebars_template = (content = null, path = null) => {
   return new Promise((resolve, reject) => {
      if (content && path) {
         $.ajax({
            url: `/components/${path}.hbs`,
            cache: false,
            success: function(template) {
               let handlebars_template = Handlebars.compile(template)
               resolve(handlebars_template(content))
            }
         }).fail(function(error) {
            reject(error)
         });
      }
   });
}